<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import Vue from "vue";
import ipcApiRoute from "./utils/bridge";
export default {
  methods: {
    //鼠标滚轮 + ctrl
    mousewheel(e) {
      if (e.ctrlKey) {
        this.$ipc
          .invoke(ipcApiRoute.handlerMouseWheel, e.wheelDelta)
          .then((r) => {
            console.log("r:", r);
          });
      }
    },
  },
  mounted() {
    if (this.$isEE) {
      //监听ctrl+鼠标滚轮事件
      window.addEventListener("mousewheel", this.mousewheel);
      this.$ipc.removeAllListeners(ipcApiRoute.ipcSendMsg);
      this.$ipc.on(ipcApiRoute.ipcSendMsg, (event, result) => {});
      const params = {
        type: "start",
        content: "开始",
      };
      this.$ipc.send(ipcApiRoute.ipcSendMsg, params);
    }
  },
};
</script>
<style lang="scss">
#app {
  width: 100%;
  height: 100%;
}
* {
  margin: 0;
  padding: 0;
}
</style>
